import { KYMW0800Model } from './../kymw0800.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 実績履歴登録クラス
 *
 * @export RegistPlanNumService
 * @class RegistPlanNumService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class RegistPlanNumService extends PlessJsonResponderSub<any> {
  // 処理に使用するModel
  private model: KYMW0800Model;
  private vo: any;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof RegistPlanNumService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        PCode: this.vo.pCode,
        CoopCode1: this.vo.coopCode1,
        CoopCode2: this.vo.coopCode2,
        CoopCode3: this.vo.coopCode3,
        CoopCode4: this.vo.coopCode4,
        CoopCode5: this.vo.coopCode5,
        CoopCode6: this.vo.coopCode6,
        CoopCode7: this.vo.coopCode7,
        CoopCode8: this.vo.coopCode8,
        NumPi1: this.vo.numPi1,
        NumPi2: this.vo.numPi2,
        NumPi3: this.vo.numPi3,
        NumPi4: this.vo.numPi4,
        NumPi5: this.vo.numPi5,
        NumPi6: this.vo.numPi6,
        NumPi7: this.vo.numPi7,
        NumPi8: this.vo.numPi8,
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof RegistPlanNumService
   */
  execute(model: KYMW0800Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW0800RegistPlanNum', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof RegistPlanNumService
   */
  success(data: any): void {
    this.model.setRegistPlanNum(data);
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
